import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#arbeitsloser

	{
		"sonstigesEinkommenMonatlich": schemaBigDecimal
	}

*/

export const schemaEuropaceArbeitsloser = z.object({
    sonstigesEinkommenMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceArbeitsloser = z.infer<typeof schemaEuropaceArbeitsloser>;
